/* eslint-disable react-hooks/exhaustive-deps */

import { useLocation } from "react-router-dom";
import { LoadingIcon } from "utils/constant";
import SingleAdvocateAccusedForRegional from "./SingleAdvocateAccusedForRegional";
import SingleAdvocateAccusedForZonal from "./SingleAdvocateAccusedForZonal";

export default function SingleAdvocateAccused() {
  const { state } = useLocation();

  if (!state)
    return (
      <div className="flex justify-center items-center h-96">{LoadingIcon}</div>
    );

  return state?.is_regional ? (
    <SingleAdvocateAccusedForRegional />
  ) : (
    <SingleAdvocateAccusedForZonal />
  );
}
